// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__2V41I","content":"Loader_content__4ewxe","tooltip":"Loader_tooltip__9cgZt"};